import AlertsContext from "common/providers/alerts";
import useRouter from "common/hooks/use-router";
import useItem from "common/hooks/useItem";
import { useCallback, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useAuth from "common/hooks/useAuth";
import TagForm from "./TagForm";

function Tag() {
  const { t } = useTranslation();
  const router = useRouter();
  const { user: currentUser } = useAuth();
  const { setAlert } = useContext(AlertsContext);

  const id = router.query.id as string;

  const { saveItem, updateItem, item, error, isFetching }: any = useItem(
    "tags",
    id,
    {}
  );

  useEffect(() => {
    if (error) {
      setAlert(error, "danger");
    }
  }, [error, setAlert]);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t("common.saved"), "success");
      router.navigate(currentUser?.isSuperadmin ? "/tags" : "/");
    }
  }, [setAlert, router, error, currentUser, t]);

  const onSubmit = useCallback(
    async (dataTag: any) => {
      const newTag = { ...dataTag };

      try {
        if (newTag.id) {
          await updateItem(newTag.id, newTag);
        } else {
          await saveItem(newTag);
        }
      } catch (e: any) {
        return e;
      }
      back();
      return true;
    },
    [updateItem, back, saveItem]
  );

  return isFetching || (id && !item) ? null : (
    <TagForm onSubmit={onSubmit} tag={item} />
  );
}

export default Tag;
